<template>
  <div class="page strategy">
    <navigation>新手专区</navigation>
    <img class="pic-banner" src="./images/img_xinshouzhuanqu.png" alt="">
    <!-- <img src="./images/img_xinshou_1.png" alt="" class="pic1"> -->
    <img src="./images/img_xinshou_2.png" alt="" class="pic2">
    <img src="./images/img_xinshou_3.png" alt="" class="pic3">
    <div class="container4">
      <img src="./images/img_xinshou_4@2x.png" alt="" class="pic4">
      <img src="./images/arrow_0.png" alt="" class="arrowdown">
    </div>
    <div class="container5">
      <img src="./images/img_xinshou_5.png" alt="" class="pic5">
      <img src="./images/arrow_0.png" alt="" class="arrowdown">
    </div>
    <div class="container6">
      <img src="./images/img_xinshou_6.png" alt="" class="pic6">
      <img src="./images/arrow_0.png" alt="" class="arrowdown">
    </div>
    <img src="./images/img_xinshou_7.png" alt="" class="pic7">
    <img src="./images/img_xinshou_8.png" alt="" class="pic8">
    <div class="container9">
      <img src="./images/img_xinshou_9.png" alt="" class="pic9">
      <img src="./images/arrow_0.png" alt="" class="arrowdown">
    </div>
    <div class="container10">
      <img src="./images/img_xinshou_10.png" alt="" class="pic10">
      <img src="./images/arrow_0.png" alt="" class="arrowdown">
    </div>
    <div class="container11">
      <img src="./images/img_xinshou_11.png" alt="" class="pic11">
      <img src="./images/arrow_0.png" alt="" class="arrowdown">
    </div>
    <img src="./images/img_xinshou_12.png" alt="" class="pic12">
    <div class="bottom" @click="callService">
      <img src="./images/icon_kefu.png" alt="">
      <span>联系客服</span>
    </div>
  </div>
</template>

<script>
import { mockHrefJump } from '../../assets/utils'
export default {
  name: 'strategy',
  data () {
    return {
      customerServicePhone: '4000100008'
    }
  }, 
  methods: {
    callService () {
      mockHrefJump(`tel:${this.customerServicePhone}`)
    }
  }
}
</script>

<style scoped lang='less'>
@import "../../assets/less/mixin.less";

    .page.strategy {
      background-color: #f9f9f9;
      min-height: 100%;
      padding-bottom: 212px;
      position: relative;
      .arrowdown {
        position: absolute;
        left: 50%;
        width: 44px;
        height: 50px;
        bottom: 0px;
      }

      // width: 750px;
      .pic-banner {
          width: 750px;
          margin: 0px;
          height: 250px;
      }
      .pic1  {
        height: 680px;
        margin-top: 40px;
      }
      .pic2  {
        height: 518px;
        margin-top: 8px;
      }
      .pic3 {
        width: 666px;
        height: 248px;
        margin: 100px 30px 0px 45px;
      }
      .container4 {
        position: relative;
        height: 350px;
        .pic4 {
          height: 323px;
          margin-top: 24px;
        }
      }

      .container5 {
        position: relative;
        height: 350px;
        .pic5 {
          height: 306px;
          margin-top: 24px;
        }
      }
      .container6 {
        position: relative;
        height: 350px;
        .pic6 {
          height: 306px;
          margin-top: 24px;
        }
      }
      .pic7 {
        height: 306px;
        margin-top: 24px;
      }
      .pic8 {
        height: 121px;
        margin: 71px 40px 0px 46px;
      }
      .container9 {
        position: relative;
        height: 350px;
        .pic9 {
          height: 324px;
          margin-top: 24px;
        }
      }
      .container10 {
        position: relative;
        height: 350px;
        .pic10 {
          height: 308px;
          margin-top: 24px;
        }
      }
      .container11 {
        position: relative;
        height: 350px;
        .pic11 {
          height: 306px;
          margin-top: 24px;
        }
      }
      .pic12 {
        height: 309px;
      }

      .bottom {
        position: absolute;
        background-color: #FFFFFF;
        width: 200px;
        height: 60px;
        bottom: 80px;
        border-radius: 40px;
        border: 1px solid #EEEEEE;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        img {
          margin-top: 14px;
          width: 32px;
          height: 32px;
        }
        span {
          margin-top: 10px;
          margin-left: 8px;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 37px;
        }
      }
    }
</style>